import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1201Model } from '../kymw1201.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// リクエスト構造
interface RegistCycleInfoRequest {
  regist: {
    CycleInfoList: {
      condition: {
        /** 受注コード */
        OrderCode: string;
        /** 媒体区分 */
        MediumType: string;
        /** バイヤーコード */
        BuyerCode: string;
      },
      combination: Conditions[];
    },
  }
};

interface Conditions {
  condition: {
    /** Pコード */
    PCode: string;
    /** アイテムコード */
    ItemCode: string;
    /** 特集コード */
    SpecialFeature: string;
    /** 注文コード割当コード */
    OrderNumQuotaCode: string;
    /** W・媒体内 */
    MediumWPublishFlg: string;
    /** クロス設定確定 */
    CrossDecisionFlg: string;
    /** クロスコード */
    CrossCode: string;
    /** 価格プロモーション */
    PricePromotion: string;
    /** コマプロモーション */
    KomaPromotion: string;
    /** プロモーションマーク */
    PromotionMark: string;
  }
};

interface WarningList {
  PCodeList: Array<string>;
  MessageID: string;
}
interface CheckErrorList {
  MessageID: string;
  Parameter1: string;
  Parameter2: string;
  Parameter3: string;
  Parameter4: string;
  Parameter5: string;
}

export interface RegistCycleInfoResponce {
  CheckResult: string;
  MessageID: string;
  Message: string;
  WarningList: Array<WarningList>;
 CheckErrorList: Array<CheckErrorList>;
}

/**
 * サイクル情報登録サービス
 * @export RegistCycleInfo
 * @class RegistCycleInfo
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistCycleInfo extends PlessJsonResponderSub<any> {
  private model: KYMW1201Model;
  private calbak: (data: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistCycleInfo
   */
  private getBody(): PlessRequest {
    const conditions = [] as Conditions[];
    for (const info of this.model.registCycleInfo.registCycleInfoList) {
      conditions.push({
        condition: {
          PCode: info.pCode ?? '',
          ItemCode: info.itemCode ?? '',
          SpecialFeature: info.specialFeature ?? '',
          MediumWPublishFlg: info.mediumWPublishFlg ?? '',
          OrderNumQuotaCode: info.orderNumQuotaCode ?? '',
          CrossDecisionFlg: info.crossDecisionFlg ?? '',
          CrossCode: info.crossCode ?? '',
          PricePromotion: info.pricePromotion ?? '',
          KomaPromotion: info.komaPromotion ?? '',
          PromotionMark: info.promotionMark ?? '',
        }
      });
    }

    const request: RegistCycleInfoRequest = {
      regist: {
        CycleInfoList: {
          condition: {
            OrderCode: this.model.orderCode,
            MediumType: this.model.mediumType,
            BuyerCode: this.model.buyerCode,
          },
          combination: conditions
        }
      }
    }

    return new PlessRequest(request);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistCycleInfo
   */
  execute(model: KYMW1201Model, f: (param: any) => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('registCycleInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistCycleInfo
   */
  success(data: RegistCycleInfoResponce) {
    if (this.calbak) this.calbak(data);
  }
}
